import { cva } from 'class-variance-authority';
import { FC } from 'react';

import ComparisonHeaderLogo from 'components/Tables/Comparison/components/ComparisonHeaderLogo';
import MobileComparisonRow from 'components/Tables/Comparison/components/MobileComparisonRow';
import { ComparisonTableConfigProps } from 'components/Tables/Comparison/config';

import { hasArrayValues } from 'utils/array/arrays';

interface MobileComparisonTableProps extends Pick<ComparisonTableConfigProps, 'rows' | 'competitor'> {
  isPrismatic?: boolean;
}

const mobileTableStyles = cva('flex flex-col overflow-hidden rounded-lg border bg-white/10', {
  variants: {
    isPrismatic: {
      true: 'border-primary-300',
      false: 'border-white/10',
    },
  },
  defaultVariants: {
    isPrismatic: false,
  },
});

const mobileHeaderStyles = cva('flex w-full justify-center p-5', {
  variants: {
    isPrismatic: {
      true: 'bg-primary-300 text-white',
      false: 'bg-white/10 text-white',
    },
  },
  defaultVariants: {
    isPrismatic: false,
  },
});

const MobileComparisonTable: FC<MobileComparisonTableProps> = ({ isPrismatic, rows, competitor }) => (
  <ul className={mobileTableStyles({ isPrismatic: !!isPrismatic })}>
    <li className={mobileHeaderStyles({ isPrismatic: !!isPrismatic })}>
      <ComparisonHeaderLogo isPrismatic={isPrismatic} competitor={competitor} />
    </li>
    {hasArrayValues(rows) && rows.map(row => <MobileComparisonRow key={row.id} isPrismatic={isPrismatic} {...row} />)}
  </ul>
);

export default MobileComparisonTable;
